module.exports = __webpack_public_path__ + "static/img/case10.6c59e0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case10.jpg
// module id = WEjT
// module chunks = 0